import React from 'react';

import { Typography, CardMedia } from '@material-ui/core';
import ES from 'components/ExplainString';
import Experience from 'components/Experience';
import ProjectLink from 'components/ProjectLink';


import explains from 'data/explains'

import {Grid} from '@material-ui/core';

export default function gen(props){
  return (<>
    <Experience
      organization='Imperial College London'
      startDate='Oct 2017'
      endDate='Jun 2021'
      title={<><ES {...explains['EIE']}>EIE</ES>  (MEng, Computer Science and Electronic Engineering)</>}
    >

      <ul>
        <li>Completing Bachelor with Master in <ES {...explains['QSRank']}>8th Globally Ranked University</ES></li>

        <li>Estimated to complete with First-Class Honours (72% Rolling Average)</li>

        <li>Implemented <ES {...explains['RaftRef']}>Raft Consensus algorithm</ES> using <ES {...explains['Elixir']}>Elixir</ES> <ProjectLink {...props} id='raft'/></li>

        <li>Built a robot with extendible arm and wrote particle filter model, won third place along 20 groups <ProjectLink {...props} id='robotics'/></li>

        <li>Wrote a Compiler which can Compile ANSI C to MIPS Assembly and Python <ProjectLink {...props} id='C90Compiler'/></li>

      </ul>
    </Experience>

    <Experience
      organization='Abbey College London'
      startDate='Sep 2015'
      endDate='Jun 2017'
      title='A Level'
    >

      <ul>
        <li>Further Mathematics (A*), Mathematics(A*), Physics (A), Chemistry (A)</li>
      </ul>

    </Experience>
  </>)
}
